var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCowriter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1836_15485)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1836_15485",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1836_15485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6779 3.35633C8.80366 3.00883 9.30288 3.00883 9.42864 3.35633C9.96048 4.82616 10.983 7.38226 12.0055 8.45379C13.0306 9.52815 15.3469 10.6025 16.6666 11.1586C16.9888 11.2945 16.9888 11.8011 16.6666 11.9369C15.3468 12.493 13.0306 13.5674 12.0055 14.6416C10.983 15.7132 9.96048 18.2694 9.42864 19.7391C9.30288 20.0866 8.80366 20.0866 8.6779 19.7391C8.14606 18.2694 7.12356 15.7132 6.10108 14.6416C5.07858 13.57 2.63951 12.4986 1.23699 11.9412C0.905382 11.8094 0.905381 11.2863 1.23697 11.1545C2.63949 10.5969 5.07858 9.52536 6.10108 8.45379C7.12356 7.38226 8.14606 4.82616 8.6779 3.35633Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0423 0.257417C16.1784 -0.0858057 16.69 -0.0858057 16.8261 0.257417C17.1086 0.970548 17.5095 1.8469 17.9103 2.26697C18.3136 2.68963 19.1166 3.11231 19.7621 3.40878C20.0802 3.55489 20.0802 4.07306 19.7621 4.21916C19.1166 4.5156 18.3136 4.93824 17.9103 5.36092C17.5095 5.78098 17.1086 6.65733 16.8261 7.37046C16.69 7.71368 16.1784 7.71368 16.0423 7.37046C15.7598 6.65733 15.3588 5.78098 14.9581 5.36092C14.5572 4.94084 13.721 4.52078 13.0405 4.22462C12.7131 4.08208 12.7131 3.54587 13.0405 3.40331C13.721 3.10713 14.5572 2.68703 14.9581 2.26697C15.3588 1.8469 15.7598 0.970548 16.0423 0.257417Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75659 2.31369C1.90506 1.97616 2.42624 1.97616 2.57471 2.31369C2.74326 2.69689 2.94651 3.08583 3.14974 3.29881C3.35567 3.51464 3.71795 3.73046 4.0696 3.90848C4.38234 4.06681 4.38234 4.59351 4.0696 4.75182C3.71793 4.92983 3.35567 5.14564 3.14974 5.36146C2.94651 5.57444 2.74326 5.96338 2.57471 6.34658C2.42624 6.68411 1.90506 6.68411 1.75659 6.34658C1.58802 5.96338 1.38479 5.57444 1.18156 5.36146C0.978328 5.14848 0.607207 4.93549 0.241561 4.75884C-0.0805104 4.60325 -0.0805252 4.05705 0.241546 3.90146C0.607192 3.7248 0.978328 3.5118 1.18156 3.29881C1.38479 3.08583 1.58802 2.69689 1.75659 2.31369Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1836_15485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCowriter);
export default __webpack_public_path__ + "static/media/cowriter.70d541fb6ccad5a685b4791a2e16a8f5.svg";
export { ForwardRef as ReactComponent };